<template>
  <div class="w-screen h-full pin-t pin-r justify-end fixed overflow-hidden"  style="z-index: 40"
      >
    <div class="bg-white h-full absolute pin-r pin-t w-full xl:w-140 lg:w-134 flex justify-start flex-col"
         :style="{'transform': `translateX(${-default_width}rem)`}">
      <font-awesome-icon @click.prevent="transformWidth(0, -1)"
                         class="cursor-pointer absolute text-black pin-r pin-t mt-4 mr-10 lg:mt-12 lg:mr-40 xl:mt-10 xl:mr-28 text-5xl lg:text-5xl xl:text-6xl"
                         :icon="['fal', 'times']"></font-awesome-icon>
      <div class="flex flex-col items-start pt-32 px-4 lg:px-8 xl:px-8">
        <div>
          <nav class="ml-6 flex items-start whitespace-no-wrap flex flex-col">
            <a
                    href="https://party.mozgo.com/"
                    class="text-main-text mx-2 hover:opacity-75 opacity-100 font-normal text-base-lg no-underline outline-none my-4 cursor-pointer"
                    style="transition: all 0.5s"
            >MozgoParty</a>
            <a href="https://partners.mozgo.com/?utm_source=mozgocom" class="">
            <button

                    class="text-main-text mx-2 hover:opacity-75 opacity-100 font-normal text-base-lg outline-none my-4 cursor-pointer"
                    style="transition: all 0.5s"
            >Купить франшизу</button> </a>
            <a
                    href="https://corp.mozgo.com?utm_source=mozgo"
                    class="text-main-text mx-2 hover:opacity-75 opacity-100 font-normal text-base-lg outline-none my-4 cursor-pointer no-underline"
                    style="transition: all 0.5s"
            >Заказать корпоратив</a>
            <a
                    href="https://basemozgo.notion.site/Mozg-d69190a80a684e0c9c0f5dbd7a07847b"
                    class="text-main-text mx-2 hover:opacity-75 opacity-100 font-normal text-base-lg outline-none my-4 cursor-pointer no-underline"
                    style="transition: all 0.5s"
                    v-if="city_id === 5"
            >Вакансии</a>
            <!-- <button
                    @click.prevent="$router.push('/timetable')"
                    class="text-main-text mx-2 hover:opacity-75 opacity-100 font-normal text-base-lg outline-none my-4 cursor-pointer"
                    style="transition: all 0.5s"
            >Расписание</button> -->
          </nav>
        </div>

      </div>
      <!-- <div class="mt-auto footer flex flex-row items-center">
        <div class="border-2 rounded-full w-16 h-16 flex ml-3 flex-row items-center justify-center relative  avatar">
          <div class="avatar overflow-hidden justify-center flex rounded-full w-full h-full relative">
            <img class="" v-if="user.avatar_url" :src="user.avatar_url"/>
            <img class="h-full w-2/5" v-else src="@/assets/SVG/avatar-white.svg"/>
          </div>
        </div>
        <div class="flex items-center w-4/5 grid pl-3">
          <button v-if="Object.keys(user).length && $route.meta.layout !== 'players'" @click.stop.prevent="cabinet" class="mr-3 text-white font-bold text-sm account cursor-pointer">
            Личный кабинет
          </button>
          <button v-if="!Object.keys(user).length" @click.stop.prevent="login" class="text-white font-bold text-sm login cursor-pointer">
            Войти
          </button>
          <img v-if="Object.keys(user).length" class="cursor-pointer logout" @click.stop.prevent="logout" src="@/assets/SVG/account-logout-white.svg"/>
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import client from '@/clients/partners';
import players from '@/clients/player';
import OnClickOutside from '../../OnClickOutside';

export default {
  name: 'desktop-menu',
  components: { OnClickOutside },
  data() {
    return {
      default_width: -27,
    };
  },
  created() {
    this.transformWidth(0, 1);
  },
  methods: {
    ...mapActions(['refreshUser']),
    updateUser() {
      if (this.user.role === 'player') this.refreshUser(players);
      else this.refreshUser(client);
    },
    cabinet() {
      if (this.user.role === 'player') this.$router.push('/players');
      else this.$router.push('/partners');
    },
    logout() {
      this.$store.dispatch('logout');
      this.showComponent = !this.showComponent;

      this.$router.push('/');
    },
    login() {
      this.$emit('registration_open');
    },
    close() {
      this.transformWidth(0, -1);
    },
    transformWidth(counter, direction) {
      if (counter < 54) {
        setTimeout(() => {
          if (direction < 0) {
            this.default_width -= 0.5;
          }

          if (direction > 0) {
            this.default_width += 0.5;
          }
          counter++;
          this.transformWidth(counter, direction);
        }, 0.2);
      }
      if (counter === 54 && direction < 0) {
        this.$emit('close');
      }
    },
  },
  computed: {
    ...mapState({
      city_id: state => state.user.cityProps.id}),
    user() {
      return this.$store.getters.userInfo || {};
    },
  },
};
</script>

<style scoped>
  html, body {margin: 0; height: 100vh; overflow: hidden}

  .footer {
    height: 6.25rem;
    width: 100%;
    background: #4A0045;
  }

  .avatar {
    object-fit: contain;
    object-position: center center;
  }

  .grid {
    display: grid !important;
    grid-template-columns: repeat(6, 1fr);
    grid-template-rows: 1fr;
  }
  .grid .login {
    grid-column-start: 1;
    grid-column-end: 2;
  }
  .grid .account {
    grid-column-start: 1;
    grid-column-end: 5;
    text-align: center;
  }
  .grid .logout {
    grid-column-start: 6;
    grid-column-end: 6;
    text-align: center;
  }
</style>
